<template>
  <div class="content">
    <div class="contentPrincipal">
      <div class="myContent">
      <div class="tabContent">
        <div class="tabElement contrat active" @click="changeTab('contrat')">
          <span class="material-icons-sharp"> person_outline </span
          >Déchargement compte utilisateur
        </div>
        <div class="tabElement money " @click="changeTab('money')">
          <span class="material-icons-sharp"> sync_alt </span
          >Demande de transaction interne
        </div>
      </div>
</div>
      <div id="contratTab" class="tabElementContent active">
        <!-- <div @click="addNewCustomer" class="buttonAdd">
            <span> Ajouter un nouveau client </span>
          </div> -->
          <!-- {{ userWalletData }} -->
          <div class="wallet">
          <div class="grid-container">
            <div v-for="( item, index) in userWalletData" :key="index" class="card">
              <!-- v-if="UserProfile.role == 'Caisse' || UserProfile.role == 'Administrateur' || UserProfile.role == 'Responsable financier'" class="wallet" -->
              <span class="title"> {{ item.user ? item.user.fullName  : '---'}}</span>

              <span class="price">
                {{
                  item.user && item.user.wallet ?  item.user.wallet.balance : 0
                }} </span
              >
            </div>
          </div>
        </div>
        <div v-if="UserProfile.role == 'Responsable financier' || UserProfile.role == 'Administrateur'" class="contentLists">
          <table class="contentListeTable">
            <thead>
              <tr>
                <th v-for="item in tableHeader" :key="item">{{ item }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
               
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in userWalletData"
                :key="item._id"
              >
              <td>
                  <div v-if="UserProfile.role != 'Administrateur'" class="nameContentButton">
                    <div
                      @click="videMoneyToUser(item)"
                      class="buttonAddSecond"
                    >
                      <span> Vider le compte</span>
                    </div>
                  </div>
                </td>
                <td>
                  {{ item.user.fullName }}
                </td>
                <td>
                  {{ item.user.jobTitle }}
                </td>
                <td v-for="element in item.paymentMethods" :key="element">
                  {{ element.balance }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div id="moneyTab" class="tabElementContent">
        <div @click="addNewMoneyRequest" class="buttonAdd">
            <span> Faire une demande de retrait </span>
          </div>
        <div class="contentLists">
          <table class="contentListeTable">
            <thead>
              <tr>
                <th v-for="item in tableHeaderRequest" :key="item">{{ item }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                @click="editeMoneyRequestRow(item)"
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in requestusertransactionData"
                :key="item._id"
              >
                <td>
                  {{ item.status === 'Acceptée' && item.files.length === 0 ? 'En attente de preuve' : (item.status === 'Acceptée' && item.files.length > 0 ? 'Terminé' : item.status) }}
                </td>
                <td>
                  {{ item.label }}
                </td>
                <td>
                  {{ item.amount }}
                </td>
                <td>
                  {{ item.type }}
                </td>
                <td>
                  {{ item.observation }}
                </td>
  
                <!-- <td>
                  {{ item.requestTo ? item.requestTo.fullName : '' }}
                </td> -->
                <td>
                  {{ item.requestAcceptBy ? item.requestAcceptBy.fullName :'' }}
                </td>
                <td>
                  {{ item.requestAcceptAt }}
                </td>
                <td>
                  {{ item.requestRejecttBy ? item.requestRejecttBy.fullName :'' }}
                </td>
                <td>
                  {{ item.requestRejecttAt }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
      
      <script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "comptabiliteView",
  components: {},
  data: () => ({
    tableHeader: [
      " ",
      "Nom ",
      "Titre",
      "Solde Portefeuille",
      "Solde Espèces",
      "Solde À crédit",
      "Solde Chèque",
      "Solde Virement",
      "Solde Ristourne"
    ],
    tableHeaderRequest: [
      "Statut ",
      "Libellé de transaction",
      "Montant",
      "Type",
      "Observation",
      // "Demander a",
      "Acceptée par",
      "Acceptée le",
      "Rejetée par",
      "Rejetée le",




    ],
    isSelecteds: [],
    isSelectedAll: false,
  }),
  computed: {
    ...mapGetters([
      //   "contratData",
      //   "blData",
      //   "conteneurData",
      //   "contenuerAllData",
      //   "storeData",
      "UserProfile",
      "userWalletData",
      "requestusertransactionData"
    ]),
  },
  async mounted() {
    await this.getUserWalletData({});
  },
  methods: {
    ...mapActions([
      //   "getContrat",
      //   "getSupplier",
      //   "getContratDetails",
      //   "getBl",
      //   "getConteneur",
      //   "getConteneurAll",
      //   "getTransitaire",
      //   "getStore",
      "getUserWalletData",
      "getRequestUserTransaction"
    ]),
    raccourcirTexte(texte) {
      return texte;
    },
    async addNewMoneyRequest() {
      this.$emit("show",true)
      const value = {
        modalType: "moneyRequest",
      };
      //   alert(item);
      this.$emit("editeRowForDash", {
        name: "moneyRequest",
        size: 300,
        value: value,
      });
      this.$emit("show",false)
    },
    editeMoneyRequestRow(item) {
      this.$emit("show",true)
      if (!item.isSelected) {
        for (let i = 0; i < this.requestusertransactionData.length; i++) {
          this.requestusertransactionData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.requestusertransactionData);
        const value = {
          _id: item._id,
          modalType: "moneyRequest",
          label: item.label,
          amount: item.amount,
          observation: item.observation,
          status: item.status,
          imageLink: item.files && item.files.length > 0 ? item.files[0] : '',
          paymentMethod: item.paymentMethod
        };
        this.$emit("editeRowForDash", {
          name: "moneyRequest",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show",false)
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    videMoneyToUser(item) {
      this.$emit("show",true)
      if (!item.isSelected) {
        for (let i = 0; i < this.userWalletData.length; i++) {
          this.userWalletData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.userWalletData);
        const value = {
          _id: item.user._id,
          modalType: "videMoneyToUser",
          fullName: item.user.fullName,
          jobTitle: item.user.jobTitle,
          paymentMethods: item.paymentMethods,
        };
        this.$emit("editeRowForDash", {
          name: "videMoneyToUser",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show",false)
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async changeTab(tabName) {
      this.$emit("show",true)
      this.$emit("closeAllModal");
      if (tabName === "contrat") {
        await this.getUserWalletData({});
      } else if (tabName === "money") {
        await this.getRequestUserTransaction({});
      } else if (tabName === "conteneur") {
        await this.getConteneurAll({ alreadyInStock: "Oui" });
      } else if (tabName === "conteneurWait") {
        await this.getConteneurAll({ alreadyInStock: "Non" });
      }
      // Masquer tous les onglets
      var tabContents = document.querySelectorAll(".tabElementContent");
      tabContents.forEach(function (tabContent) {
        tabContent.classList.remove("active");
      });

      // Afficher l'onglet sélectionné
      var selectedTab = document.getElementById(tabName + "Tab");
      selectedTab.classList.add("active");

      // Mettre à jour l'état actif des onglets de la barre de navigation
      var tabElements = document.querySelectorAll(".tabElement");
      tabElements.forEach(function (tabElement) {
        tabElement.classList.remove("active");
      });

      var selectedTabElement = document.querySelector(".tabElement." + tabName);
      selectedTabElement.classList.add("active");
      this.$emit("show",false)
    },
  },
};
</script>
      